import React, { Component, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

import { LayoutPlain, Header } from 'components/layout'
import { MaterialLoader } from 'components/loaders'
import { apiPayment } from 'helpers/decorators/api'
import PropTypes from 'prop-types'
import { Title } from 'components/misc'

const STATUS = {
  START: 0, // API is contacted to init GP WP payment
  ERROR: -1, // something went wrong
  INITIALIZED: 1 // We've got request PARAMS from gateway and user is beeing redirected
}

@apiPayment()
class PaymentGPWPInit extends Component {
  static propTypes = {
    initializeGpWp: PropTypes.func
  }

  state = {
    hppData: null,
    error: null,
    status: STATUS.START
  }

  async componentDidMount() {

    if (__SERVER__) {
      return
    }

    try {
      const hppData = await this.props.initializeGpWp()

      this.setState({ hppData, status: STATUS.INITIALIZED })
    } catch (error) {
      this.handleError(error)
    }
  }

  handleError = error => {
    console.error(error)
    this.setState({ error, status: STATUS.ERROR })
  }

  render() {
    const { status } = this.state

    return (
      <LayoutPlain
        header={<Header isLocaleHidden />}
        body={[
          <Fragment>
            <div>
              {status === STATUS.ERROR &&
                <Fragment>
                  <Title h1 intlKey="moduleTitle.payment" className="base-margin--top">
                    Participant registration fees payment
                  </Title>
                  <Title h3 intlKey="label.problem_with_payment">
                  There was a problem processing your payment. Please contact your
                  National Award Operator (NAO).
                  </Title>
                </Fragment>
              }

              {(status === STATUS.START || status === STATUS.INITIALIZED) &&
                <h1>
                  <MaterialLoader />{' '}
                  <span style={{ marginLeft: 10, position: 'relative', top: -7 }}>
                    <FormattedMessage
                      id="label.loading_gp_gateway"
                      defaultMessage="Loading Global Payments Gateway"
                    />
                  </span>
                </h1>
              }
            </div>
          </Fragment>
        ]}
      />
    )
  }
}

export default PaymentGPWPInit
